import { Injectable } from '@angular/core';
import { Messaging } from '@angular/fire/messaging';
import { getToken, onMessage } from 'firebase/messaging';
import { environment } from '../../environment/environment'
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../components/modal/modal.component'
import { UserDataService } from './userData.service';
import { UserRole } from '../constants/constants';
import { ApiService } from './communications/api.service';

@Injectable({
  providedIn: 'root'
})

export class PushNotificationService {
    constructor(private messaging: Messaging, private dialog: MatDialog, private userDataService: UserDataService, private apiService: ApiService) { }

    public async startService(): Promise<void> {   
        if(this.userDataService.isExpert()) {
            return;
        }
        
        if (Notification.permission === "granted") {
            getToken(this.messaging, {
            vapidKey: environment.firebaseConfig.vapidKey,
        })
        .then((currentToken: string) => {
            if (currentToken) {            
                this.sendFirebaseToken(currentToken);
            } else {
                console.log("Error taking Firebase token.");
            }
          })
          .catch((err: any) => {
            console.log(err);
          }); 
        } else {
            const askPNPermissionsDialog = this.dialog.open(ModalComponent, {
            autoFocus: true,
            data: {
                title: 'NOTIFICATIONS.PERMISSIONS_TITLE',
                message: 'NOTIFICATIONS.PERMISSIONS_BODY',
                addButtons: true
            }
            });
        
            askPNPermissionsDialog.afterClosed().subscribe(async (result: boolean) => {
                if (result == true) {
                    let currentToken = await this.requestPushNotificationPermission();
                    this.sendFirebaseToken(currentToken);
                }            
            });
        }
    }

    private async requestPushNotificationPermission(): Promise<string> {
        console.log('Requesting permission...');
        Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            getToken(this.messaging, {
            vapidKey: environment.firebaseConfig.vapidKey,
            })
            .then((currentToken: string) => {
                if (!currentToken) {
                    console.log("It's not possible to generate Firebase token. Are messages notifications? Are you using incognito mode?");
                }
                return currentToken;
            })
            .catch((err: any) => {
                console.log(err);
            });
        }
        });

        return '';
    }

    private async sendFirebaseToken(token:string) {

        if(!token || !this.userDataService.Id || !this.userDataService.Role) {
            console.log("It is not possible to send Firebase token to server. Notifications may not work properly.");
            return;
        }

        this.apiService.sendFirebaseToken(this.userDataService.Id, this.userDataService.Role, token).subscribe({
            next: () => {
                console.log("Firebase token sent OK.");            
            },
            error: (error) => { "Firebase token error: " + console.error(error); }
        });
    }
}